import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { IAfterGuiAttachedParams } from 'ag-grid-community';
import { UserIdToNamePipe } from '../pipes/user-id-to-name.pipe';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'user-name-cell',
    template: `{{ value | userIdToName | async }}`,
    standalone: true,
    imports: [AsyncPipe, UserIdToNamePipe]
})
export class UserNameCellComponent implements AgRendererComponent {
  value: number;

  agInit(params: any): void {
    if (params.value) {
      this.value = params.value;
    }
  }

  refresh(params: any): boolean {
    this.value = params.value;
    return true;
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {}
}
